import { createRootRoute, Outlet } from '@tanstack/react-router';
import { DemoModalProvider } from '../components/demo-modal-context';
import { DemoModal } from '../components/demo-modal';
import { Nav } from '../components/nav';
import { Footer } from '../components/footer';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <DemoModalProvider>
      <div className="flex min-h-full flex-col">
        <Nav />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <DemoModal />
    </DemoModalProvider>
  );
}
